// extracted by extract-css-chunks-webpack-plugin
module.exports = {"wrapper":"_34LuCI","scrollContainer":"_1bhjX2","scrollContent":"_3hUyl1","nextButton":"pI74IP","prevButton":"_3Pu9Q7"};